export default "__VITE_ASSET__Gd9ICEa5__"